// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-8b98a720] .el-image__inner,[data-v-8b98a720] .el-image__error {\n  width: 120px;\n  height: 120px;\n  margin-right: 6px;\n  border: 1px solid #DCDFE6;\n  border-radius: 4px;\n  outline: 0;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n[data-v-8b98a720] .img-url .el-form-item__content > div {\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
